export default __webpack_public_path__ + "static/media/aws.e10a5fec.svg";